import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const PAY_COLOR = {
  "Pagado": "bg-emerald-50 text-emerald-800",
  "Anticipo 50%": "bg-sky-50 text-sky-800",
  "Anticipo 30%": "bg-sky-50 text-sky-800",
  "Pendiente": "bg-amber-50 text-amber-800",
};

export default function StaffSuppliers() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/suppliers").then(r => setItems(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="staff-suppliers" className="space-y-6">
      <div>
        <div className="overline text-[var(--brand-primary)]">Proveedores</div>
        <h2 className="font-serif-cg text-3xl md:text-4xl tracking-tight mt-2">Servicios contratados</h2>
      </div>

      {loading ? (
        <p className="text-[var(--brand-muted)]">Cargando...</p>
      ) : (
        <div className="card-cg overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-[var(--brand-surface-alt)] text-left">
              <tr className="overline text-[var(--brand-muted)]">
                <th className="p-3 md:p-4">Proveedor</th>
                <th className="p-3 md:p-4">Servicio</th>
                <th className="p-3 md:p-4">Contacto</th>
                <th className="p-3 md:p-4">Costo</th>
                <th className="p-3 md:p-4">Pago</th>
              </tr>
            </thead>
            <tbody>
              {items.map((s, idx) => (
                <tr key={s.id} data-testid={`supplier-${idx}`} className={idx % 2 ? "bg-[var(--brand-surface-alt)]/50" : ""}>
                  <td className="p-3 md:p-4 font-serif-cg text-base">{s.name}</td>
                  <td className="p-3 md:p-4 text-[var(--brand-ink)]/80">{s.service}</td>
                  <td className="p-3 md:p-4 text-[var(--brand-ink)]/80">{s.contact}</td>
                  <td className="p-3 md:p-4 whitespace-nowrap">{s.estimated_cost}</td>
                  <td className="p-3 md:p-4">
                    <span className={`text-[11px] px-2 py-1 ${PAY_COLOR[s.payment_status] || "bg-stone-100 text-stone-700"}`}>
                      {s.payment_status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
